// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/VendasServicos_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Query de GET /relatorios/vendas_servicos/lista (chamado 2026-0086).
 *
 * `data_inicio` e `data_fim` são date-only (YYYY-MM-DD, sem conversão de fuso)
 * e filtram a data de criação do item. `prioridade_id` é opcional.
 */
import { registerContract } from './validate'

export interface VendasServicos_ListaInput {
data_inicio: string
data_fim: string
prioridade_id?: number
}

registerContract('VendasServicos_ListaInput', {
  data_inicio:   { type: 'string',  required: true },
  data_fim:      { type: 'string',  required: true },
  prioridade_id: { type: 'number',  required: false },
})
